import { createFileRoute } from '@tanstack/react-router';
import { SurveyPage } from '@/page/survey/SurveyPage';
import { buildSeoHead } from '@/lib/seo';

export const Route = createFileRoute('/survey')({
  component: SurveyRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    t: typeof search.t === 'string' ? search.t : undefined,
  }),
  head: () =>
    buildSeoHead({
      title: 'Fragments Waitlist Survey',
      description:
        'Five questions about how your team builds frontend today. Ninety seconds.',
      path: '/survey',
      canonicalPath: '/survey',
      keywords: ['fragments survey', 'frontend feedback'],
      index: false,
    }),
});

function SurveyRoute() {
  const { t } = Route.useSearch();
  return <SurveyPage token={t ?? null} />;
}
